<template>
	<common-transition-slide :active="hasNotifications" :duration="250">
		<common-card
			v-if="hasNotifications"
			class="omapi-notifications"
		>
			<div class="flex">
				<div class="omapi-notifications__image omapi-multi-column__secondary">
					<icons-notification-bell :type="$get('current.type', 'info')"/>
				</div>
				<div
					class="omapi-multi-column__primary"
					@keydown.right="scrollRight"
					@keydown.left="scrollLeft"
				>
					<notifications-single
						:notification="current"
						:loading="dismissing"
						ref="notifications"
						@remove="remove"
					/>
					<div
						v-if="1 < notifications.length"
						class="omapi-notifications__nav"
					>
						<span class="omapi-pagination__count">{{ index + 1 }} of {{ notifications.length }}</span>
						<core-button
							type="secondary"
							class="omapi-pagination__button omapi-pagination__button-symbol"
							:disabled="0 >= index"
							@click.stop.prevent="scrollLeft"
						>‹</core-button>
						<core-button
							type="secondary"
							class="omapi-pagination__button omapi-pagination__button-symbol"
							:disabled="index >= notifications.length - 1"
							href="#"
							@click.stop.prevent="scrollRight"
						>›</core-button>
					</div>
				</div>
			</div>
		</common-card>
	</common-transition-slide>
</template>

<script lang="js">
import { notifications } from '@/notifications/mixins/notifications'

export default  {
	data () {
		return {
			index : 0,
		}
	},
	mixins   : [ notifications ],
	computed : {
		current () {
			return this.notifications[this.index]
		},
	},
	methods : {
		scrollRight () {
			let highest = this.notifications.length - 1
			this.index = this.index >= highest ? highest : this.index + 1
		},
		scrollLeft () {
			this.index = 0 >= this.index ? 0 : this.index - 1
		},
	},
	mounted () {
		if (this.hasNotifications) {
			document.body.classList.add('omapi-has-notifications')
		}
	},
	beforeDestroy () {
		document.body.classList.remove('omapi-has-notifications')
	},
	watch : {
		hasNotifications (val) {
			if (this.hasNotifications) {
				document.body.classList.add('omapi-has-notifications')
			} else {
				document.body.classList.remove('omapi-has-notifications')
			}
		},
	},
}
</script>
<style lang="scss">
@import '../../assets/scss/variables';
.omapi-screen {
	.omapi-notifications {
		overflow: hidden;
		margin-top: 12px;
		&.omapi-card__notitle.omapi-card__nofooter .omapi-card-content {
			padding: 24px 17px;
		}
		&__image {
			svg {
				margin-right: 26px;
			}
		}
		&__content {
			display: flex;
			flex-direction: column;
			justify-content: space-evenly;
			height: 100%;
		}
		&__title {
			font-size: 21px;
			line-height: 1.4em;
			margin-bottom: 7px;
			font-weight: 600;
		}
		&__text {
			font-size: 13px;
			line-height: 1.5em;
			color: $font_setting-color;
			margin-bottom: 10px;
		}
		&__buttons {
			height: 27px;
			display: flex;
			align-items: center;
			.omapi-button.omapi-button__small {
				line-height: 1em;
				padding: 6px 10px;
			}
		}
		&__nav {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			margin-top: -26px;
			.omapi-button.omapi-pagination__button-symbol {
				font-size: 20px;
				font-weight: 400;
				color: $color_grey-icon-dark;
				padding: 2px 10px !important;
				line-height: 1em;
				&:hover, &:focus, &:active {
					color: $color_white;
				}
				&[disabled] {
					opacity: 0.5;
				}
			}
			.omapi-pagination__count {
				padding-right: 5px;
			}
		}
	}
}
</style>
